import React, { useEffect, useContext, useState } from "react";
import Fee from "../Components/Fee";
import Spinner from "react-bootstrap/Spinner";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import axios from "axios";
import { useParams } from "react-router-dom";

function FeesReport() {
  const [fees, setFees] = useState([]);
  const [totalFees, setTotalFees] = useState(0);
  const [totalNet, setTotalNet] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const { state } = useContext(AuthContext);

  let { rid } = useParams();

  useEffect(() => {
    async function fetch() {
      const result = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/reports/fees/stripe/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setFees(result.data.fees);
      setTotalFees(result.data.totalFees);
      setTotalNet(result.data.totalNet);
      setTotalAmount(result.data.totalAmount);
      setIsLoading(false);
    }
    fetch();
  }, []);

  if (isLoading) {
    return (
      <Col>
        <Spinner animation="border" className="mb-2" />
        <h4>Procesando... Puede tardar algunos minutos, favor de esperar.</h4>
      </Col>
    );
  } else {
    return (
      <Col className="residences">
        <Col className="residences-header">
          <Row className="align-items-center">
            <Col className="mb-2">
              <h4>Comisiones pagadas</h4>
            </Col>
          </Row>
        </Col>
        <Col className="residences-content">
          <Col>
            <Row className="align-items-center">
              <Col lg={3}>
                <h6>Fecha</h6>
              </Col>
              <Col lg={3}>
                <p>Monto</p>
              </Col>
              <Col lg={3}>
                <p>Comision</p>
              </Col>
              <Col lg={3}>
                <p>Neto</p>
              </Col>
            </Row>
          </Col>
          {fees.map((item) => (
            <Fee
              amount={item.amount}
              fee={item.fee}
              net={item.net}
              date={item.created}
              id={item.id}
              key={item.id}
            />
          ))}
        </Col>
        <Col className="fees-report-footer mt-3">
          <Row className="align-items-center">
            <Col lg={3}>
              <p>Total</p>
            </Col>
            <Col lg={3}>
              <p>${totalAmount.toLocaleString("en-US")}</p>
            </Col>
            <Col lg={3}>
              <p>${totalFees.toLocaleString("en-US")}</p>
            </Col>
            <Col lg={3}>
              <p>${totalNet.toLocaleString("en-US")}</p>
            </Col>
          </Row>
        </Col>
      </Col>
    );
  }
}

export default FeesReport;
